module.exports = __webpack_public_path__ + "img/616.a7d6a2e5.jpg";